import { craeteLauncher } from './api';
import { setBaseReqParams } from './libs';
export * from './flow';
export * from './validators';
export * from './i18n';
export * from './libs';
export * from './api';
export * from './utils';
export * from './types';
export default {
  /** 登陆 */
  signin: craeteLauncher('LoginFlow'),

  /** 第三方登录 */
  thirdSignin: craeteLauncher('ThirdLoginFlow'),

  /** 混淆注册 */
  signup: craeteLauncher('MixRegisterFlow'),

  /** 商家注册 */
  adminSinup: craeteLauncher('AdminRegisterFlow'),

  /** 激活 */
  activate: craeteLauncher('PwdActivateFlow'),

  /** 忘记密码 */
  forgotPW: craeteLauncher('PwdRetrieveFlow'),

  /** 修改密码 */
  modifyPW: craeteLauncher('PwdChangeFlow'),

  /** 绑定手机 */
  bindMobile: craeteLauncher('MobileBindFlow'),

  /** 绑定邮箱 */
  bindEmail: craeteLauncher('EmailBindFlow'),

  /** 邀请注册 */
  invite: craeteLauncher('PwdRegFlow'),

  /** 解绑 */
  unbindMobile: craeteLauncher('UnbindMobileFlow'),
  unbindEmail: craeteLauncher('UnbindEmailFlow'),

  /** 设置公共参数 */
  setBaseReqParams: setBaseReqParams
};